/* AdminTabs — real ARIA tablist with Arrow/Home/End keyboard nav,
   roving tabindex, and visible 2px focus ring. Tabs map 1:1 to the
   hash routes #/admin/<section> for shareable deep links. */
import React, { useRef } from "react";
import { P } from "../shared/constants";
var E = React.createElement;

/* Canonical tab definitions. id matches the hash slug. */
var TABS = [
  { id:"overview",     label:"Overview" },
  { id:"licenses",     label:"Licenses" },
  { id:"users",        label:"Users" },
  { id:"intake-queue", label:"Intake Queue" },
  { id:"docmaya-keys", label:"DocMaya Keys" },
  { id:"revenue",      label:"Revenue" },
  { id:"activity",     label:"Activity Log" }
];

export default function AdminTabs(props){
  var active = props.active || "overview";
  var refs = useRef([]);
  var idx = Math.max(0, TABS.findIndex(function(t){return t.id===active}));

  function onKey(e){
    var key = e.key;
    if(["ArrowLeft","ArrowRight","Home","End"].indexOf(key)<0) return;
    e.preventDefault();
    var next = idx;
    if(key==="ArrowLeft")  next = (idx - 1 + TABS.length) % TABS.length;
    if(key==="ArrowRight") next = (idx + 1) % TABS.length;
    if(key==="Home") next = 0;
    if(key==="End")  next = TABS.length - 1;
    props.onChange && props.onChange(TABS[next].id);
    /* Move focus to the newly active tab on the next paint. */
    var rafId = (typeof window!=="undefined"&&window.requestAnimationFrame)
      ? window.requestAnimationFrame(function(){ var el=refs.current[next]; if(el) el.focus(); })
      : setTimeout(function(){ var el=refs.current[next]; if(el) el.focus(); }, 0);
    return rafId;
  }

  return E("div", {
    role:"tablist",
    "aria-label":"Admin sections",
    onKeyDown:onKey,
    style:{display:"flex",gap:2,borderBottom:"1px solid "+P.bdr,
      overflowX:"auto",WebkitOverflowScrolling:"touch"}
  }, TABS.map(function(t,i){
    var selected = t.id===active;
    return E("button", {
      key:t.id,
      ref:function(el){ refs.current[i]=el; },
      role:"tab",
      type:"button",
      id:"admin-tab-"+t.id,
      "aria-selected": selected?"true":"false",
      "aria-controls":"admin-panel-"+t.id,
      tabIndex: selected?0:-1,
      onClick:function(){ props.onChange && props.onChange(t.id); },
      style:{
        padding:"10px 16px",border:"none",background:"transparent",
        borderBottom: selected?("2px solid "+P.pri):"2px solid transparent",
        color: selected?P.pri:P.slateM,
        fontWeight: selected?700:500,
        fontSize:12,
        cursor:"pointer",
        minHeight:44,
        outlineOffset:2,
        whiteSpace:"nowrap"
      }
    }, t.label);
  }));
}

export { TABS };
